import { DateTime } from 'luxon';

// -----------------------------------------------------------------------------
//! Message time ago
// -----------------------------------------------------------------------------

export function formatMessageTime(timestamp, detailed) {
	const todayDate = new Date().setHours(0, 0, 0, 0);
	const today = DateTime.fromMillis(todayDate, { zone: this.$systemTimeZone });
	const date = this.$toDateTime(timestamp, { zone: this.$systemTimeZone });
	let options;

	if (date.year !== today.year) {
		options = DateTime.DATE_MED;
		if (detailed) {
			options = {
				month: '2-digit',
				day: '2-digit',
				year: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true
			};
		} else {
			options = DateTime.DATE_MED;
		}
	} else if (date.month !== today.month || date.day !== today.day) {
		
		if (detailed) {
			options = {
				month: 'long',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true
			};
		} else {
			options = { day: 'numeric', month: 'short' };
		}
	} else {
		options = DateTime.TIME_SIMPLE;
	}
	return date.toLocaleString(options);
}

export function formatReviewDate(timestamp) {
	const todayDate = new Date().setHours(0, 0, 0, 0);
	const today = DateTime.fromMillis(todayDate, { zone: this.$systemTimeZone });
	const date = this.$toDateTime(timestamp, { zone: this.$systemTimeZone });
	let options;

	if (date.year !== today.year) {
		options = DateTime.DATE_MED;
	} else {
		options = { day: 'numeric', month: 'long' };
	}

	return date.toLocaleString(options);
}

export function stripTags(html) {
	const div = document.createElement('div');
	div.innerHTML = html;

	return div.innerText;
}

// -----------------------------------------------------------------------------
//! Event date/time
// -----------------------------------------------------------------------------

export function formatEventDate(event, monthLength) {
	const date = new Date(event.startedAt);
	const tz = event.locations[0].tz;
	const day = date.toLocaleDateString('en-US', { 
		year: 'numeric',
		month: monthLength ? monthLength : 'long',
		day: 'numeric',
		timeZone: tz,
	});
	return day;
}

export function formatEventTime(event) {
	const date = new Date(event.startedAt);
	const tz = event.locations[0].tz;
	let out = '';
	
	// Start time
	if (date.getHours() > 0) {
		let start = date.toLocaleTimeString('en-US', {
			hour: 'numeric',
			minute: 'numeric',
			hour12: true,
			timeZone: tz,
		});
		out += start.replace(' ', '').toLocaleLowerCase();

		// End time
		let end = new Date(event.endedAt);
		end = end.toLocaleTimeString('en-US', {
			hour: 'numeric',
			minute: 'numeric',
			hour12: true,
			timeZone: tz,
		});

		// If end is 11:59, user did not set one, so skip
		if (end.indexOf('11:59') == -1) {
			out += ' - ' + end.replace(' ', '').toLocaleLowerCase();
		}
	}

	return out;
}